import request from '@/utils/request'

// 加载变更单信息
export function selectInfoById(id) {
  return request({
    url: '/api/srm-slcm/pmPriceLifespanChangeApply/selectInfoById/' + id,
    method: 'get'
  })
}
